import { render, staticRenderFns } from "./smsConfig.vue?vue&type=template&id=11b4bb62&scoped=true"
import script from "./smsConfig.vue?vue&type=script&lang=js"
export * from "./smsConfig.vue?vue&type=script&lang=js"
import style0 from "./smsConfig.vue?vue&type=style&index=0&id=11b4bb62&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b4bb62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b4bb62')) {
      api.createRecord('11b4bb62', component.options)
    } else {
      api.reload('11b4bb62', component.options)
    }
    module.hot.accept("./smsConfig.vue?vue&type=template&id=11b4bb62&scoped=true", function () {
      api.rerender('11b4bb62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/smsConfiguration/cmp/smsConfig.vue"
export default component.exports